import styled, { css } from 'styled-components'
import { Row } from '@sainsburys-tech/bolt'

const Wrapper = styled(Row)`
  /*Tech debt: Quick fix to Browse height overide bug */
  height: 210px !important;
  overflow: hidden;
  text-decoration: none;
  position: relative;
  display: block;

  ${(props) =>
    css`
      margin-bottom: ${props.theme.size.spacing.lg};
      border: ${props.theme.color.monochrome.base} ${props.theme.size.border.width.sm} solid;
      border-radius: ${props.theme.size.border.radius.base};
    `}

  ${(props) =>
    props.listerPageType &&
    css`
      /*Tech debt: Quick fix to Browse height overide bug */
      height: 140px !important;
      margin-left: ${props.theme.size.spacing.lg};
      margin-right: ${props.theme.size.spacing.lg};
      @media only screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        height: 160px;
      }
      @media only screen and (min-width: ${props.theme.size.breakpoint['min-width'].lg}) {
        margin-left: 0;
        margin-right: 0;
      }
    `}

    img {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export { Wrapper }
